import * as styles from "../../../../styles/DefaultSetting";
import React, { useCallback, useEffect, useLayoutEffect, useState, useRef } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import userSlice from "../../../../reducer/user";
import { useAppDispatch } from "../../../../store";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { Farmstype } from "reduxaction/posttypes";
import styled from "styled-components/macro";
import { set } from "date-fns";
import { af, be, de } from "date-fns/locale";
import { after } from "node:test";

dayjs.locale("ko");

const SelectBoxStyleForRFID = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: stretch;
	width: 100%;
	margin-top: 5px;
	button{
		width: 44px;
		font-size: 0.75em;
		border: 1px solid #c9c9c9;
		border-radius: 5px;
		&:nth-of-type(1){
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			border-right: none;
		}
		&:nth-of-type(2){
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			border-left: none;
			border-right: none;
		}
		&.selected{
			background-color: #73972c;
			color: #fff;
		}
		&.unselected{
			background-color: rgba(247,247,247,1);
			color: rgb(101, 101, 101);
		}
		&:hover{
			cursor: pointer;
			filter: brightness(0.9);
		}
	}
	select{
		width: calc(90% - 88px) !important;
		margin-top: 0 !important;
		&[disabled]{
			background-color: #f7f7f7;
		}
	}
	input{
		width: calc(90% - 88px) !important;
		margin-top: 0 !important;
		border-top-left-radius: 0 !important;
		border-bottom-left-radius: 0 !important;
		&::placeholder{
			color: #999;
		}
	}
`;

const BoxAdd = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const [targetFarmInfo, setTargetFarmInfo] = useState<Farmstype>(); // 타겟팜 정보

	const [totaldata, setTotaldata] = useState<any>(); // 전체 데이터

	const [placeList, setPlaceList] = useState<any>([]); // 사육실 리스트
	const [sectionList, setSectionList] = useState<any>([]); // 사육구역 리스트
	const [insectList, setInsectList] = useState<any>([]); // 곤충 리스트
	const [RFIDList, setRFIDList] = useState<any>([]); // RFID 리스트

	// 사육 시작일 기본값(오늘 일자)
	const today = new Date();
	const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

	// let [containerId, setContainerId] = useState<number>(); // 초기 containerId값
	// let [container, setContainer] = useState(); // 사육실
	// let [insect, setInsect] = useState<any>(); // 곤충 선택 값
	// let [defaultInsect, setDefaultInsect] = useState<any>(); // 초기 곤충 값
	// const [RFIDBoxes, setRFIDBoxes] = useState<string[]>([]);
	// obejct를 기본값으로 가진 deaultSet
	// const [defaultSet, setDefaultSet] = useState<any>({
	// 	containerId: "",
	// 	boxName: "",
	// 	productCode: "",
	// 	startFarmDate: "",
	// });

	const [items, setItems] = useState<any[]>([
		{
			containerId: "",
			sectionId: "",
			boxName: "",
			productCode: "",
			startFarmDate: "",
		},
	]);


	// RFID (신규/재사용) 버튼
	const [selectedButtons, setSelectedButtons] = useState<string[]>(['new']);




	// targetFarmInfo 세팅
	useEffect(() => {
		const farmInfo = localStorage.getItem("targetfarmInfo");
		setTargetFarmInfo(farmInfo && JSON.parse(farmInfo));
	}, []);

	/*
	* * 🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶 API LIST
	  */
	// 사육실·사육구역 API
	const settingPlace = async (placeId: number) => {
		return await axios
			.get(`/ifactory/api/place/specificplace?placeId=${placeId}`)
			.then((res) => res.data)
			.catch((error) => {
				confirmAlert({
					title: error.response.data,
					buttons: [{ label: "Yes" }],
				});
			});
	};

	// 곤충 API
	const settingInsect = async () => {
		return await axios
			.get(`/ifactory/api/productcode`)
			.then((res) => res.data)
			.catch((error) => {
				confirmAlert({
					title: error.response.data,
					buttons: [{ label: "Yes" }],
				});
			});
	};

	// RFID API
	const settingRFID = async () => {
		const farmPlaceId = targetFarmInfo?.placeId;
		return await axios
			.get(`/ifactory/api/managebox/reuse?farmId=${farmPlaceId}`)
			.then((res) => res.data)
			.catch((error) => {
				confirmAlert({
					title: error.response.data,
					buttons: [{ label: "Yes" }],
				});
			});
	};


	/*
	* * 🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶 초기 BOX SETTING
	  */
	const beforeSetting = () => {
		const targetFarmInfo = JSON.parse(localStorage.getItem("targetfarmInfo") || '{}');
		return Promise.all([
			settingPlace(targetFarmInfo?.placeId),
			settingInsect(),
			settingRFID(),
		]);
	};

	const afterSetting = () => {
		if (!placeList[0]) {
			return Promise.reject(new Error('placeList is empty'));
		}
		return settingPlace(placeList[0].placeId);
	}

	useEffect(() => {
		if (!targetFarmInfo) return;
		beforeSetting().then(([placeRes, insectRes, rfidRes]) => {
			setPlaceList(placeRes);
			setInsectList(insectRes);
			setRFIDList([...rfidRes]);
			if (placeRes[0] && insectRes[0]) {
				setItems(prevItems => prevItems.map((item, index) => index === 0 ? {
					...item,
					containerId: placeRes[0].placeId,
					productCode: insectRes[0].productCode,
					startFarmDate: formattedDate,
				} : item));
			}
		});
	}, [targetFarmInfo]);

	useEffect(() => {
		if (placeList.length > 0) {
			afterSetting().then(sectionRes => {
				setSectionList([sectionRes]);
				if (sectionRes[0]) {
					setItems(prevItems => prevItems.map((item, index) => index === 0 ? {
						...item,
						sectionId: sectionRes[0].placeId,
					} : item));
				}
			});
		}
	}, [placeList]);


	/*
	* * 🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶🔶 EVENT
	  */
	// RFID 버튼 클릭 이벤트
	const handleButtonClick = (button: string, index: number) => {
		const newSelectedButtons = [...selectedButtons];
		newSelectedButtons[index] = button;
		setSelectedButtons(newSelectedButtons);
	};

	// 사육실의 onChange 이벤트 => 해당하는 index의 사육구역 리스트 가져오기
	const handlePlaceChange = (e: any) => {

		const index = e.target.dataset.index;
		const placeId = Number(e.target.value);

		// sectionList[index]가 있으면 업데이트, 없으면 추가
		const updateSectionList = sectionList[index]
			? settingPlace(placeId).then((res) => {
				const newSectionList = [...sectionList];
				newSectionList[index] = res;
				return newSectionList;
			})
			: settingPlace(placeId).then((res) => [...sectionList, res]);


		updateSectionList.then((newSectionList) => {
			setSectionList(newSectionList);

			// items의 해당 index의 containerId와 sectionId 업데이트
			const newItems = [...items];
			newItems[index] = {
				...newItems[index],
				containerId: placeId,
				sectionId: newSectionList[index][0]?.placeId,
			};

			setItems(newItems);
		});
	};

	// 입력 데이터 컨트롤러
	const handleChange = (e: any) => {
		if (!e.target) return;
		const target = e.target as HTMLInputElement;

		const index = Number(target.dataset?.index);
		const stateKey = target.dataset.statekey;
		const value = target.value;

		// key, value가 없으면 return
		if (!stateKey || !value) return;

		// stateKey의 항목에 따라 value type 변경하여 return  (containerId, sectionId => number) / (그 외 => string)
		const typeChangeValue = (key: string, value: string) => {
			if (key === 'containerId' || key === 'sectionId') return Number(value);
			return value;
		};


		// items에 해당 index가 있으면 업데이트
		const newItems = [...items];
		if (newItems[index]) {
			setItems(newItems.map((item, idx) => {
				if (idx === index) {
					return {
						...item,
						[stateKey]: typeChangeValue(stateKey, value),
					};
				}
				return item;
			}));
		}
	};

	// 추가 버튼 이벤트
	const handleAdd = () => {

		// sectionList에 placeList의 첫번째 요소의 placeId에 해당하는 사육구역 리스트를 추가
		const newPlace = settingPlace(placeList[0].placeId);
		newPlace.then((res) => {
			setSectionList([...sectionList, res]);
			setItems([
				...items,
				{
					containerId: placeList[0].placeId,
					sectionId: res[0].placeId,
					boxName: "",
					productCode: insectList[0].productCode,
					startFarmDate: formattedDate,
				},
			]);

			setSelectedButtons([...selectedButtons, 'new']);
		});
	};

	// 삭제 버튼 이벤트
	const handleRemove = () => {
		if (items.length === 1) {
			return confirmAlert({
				title: "삭제할 수 없습니다.",
				buttons: [
					{
						label: "Yes",
					},
				],
			});
		}
		const newItems = [...items];
		newItems.pop();
		setItems(newItems);
	};


	const PostSubmit = () => {
		axios.post(`/ifactory/api/managebox`, items)
			.then((res) => {
				confirmAlert({
					title: res.data,
					buttons: [
						{
							label: "Yes",
						},
					],
				});
				navigate("/Boxmanagement");
			})
			.catch((error) => {
				confirmAlert({
					title: error.response.data.message,
					buttons: [
						{
							label: "Yes",
						},
					],
				});
			});
	};



	return (
		<styles.Container style={{ background: "#fff" }}>
			<styles.PageTop>
				<p className="move-btn">
					<img src="./img/ArrowLeft.svg" alt="좌향화살표" onClick={() => { navigate("/Boxmanagement"); }} />
				</p>
				<p className="pagetit">기본설정</p>
				<button className="post-submit" onClick={() => { PostSubmit(); }}>작성</button>
			</styles.PageTop>
			<styles.PageTitle className="noneborder">
				<div className="title">
					<img src="./img/MiniBox.svg" alt="작은박스" />
					<p>상자 관리</p>
				</div>
			</styles.PageTitle>
			<styles.AddBoxItemContainer>


				{items && items.map((item: any, index: number) => (
					<styles.AddBoxItemList key={index} style={{display:"inline-block",paddingBottom:"10px",
						borderBottom: "10px solid #f7f7f7f7"}}>
						<div className="Itemlist" style={{display:"inline-block",float:"left",minWidth:"180px",width:"20%"}}>
							<p>사육실</p>
							<select name="containerList" onChange={handlePlaceChange} data-statekey="containerId" data-index={index}>
								{placeList && placeList.map((place: any, idx: number) => (
									items[index].containerId == place.placeId ? (
										<option key={idx} value={place.placeId}>{place.name}</option>
									) : (
										<option style={{ backgroundColor: "#9cc34e" }} key={idx} value={place.placeId}>{place.name}</option>
									)
								))}
							</select>
						</div>

						<div className="Itemlist" style={{display:"inline-block",float:"left",minWidth:"250px",width:"20%"}}>
							<p>사육 구역</p>
							<select name="sectionList" onChange={handleChange} data-statekey="sectionId" data-index={index}>
								{sectionList[index] ? sectionList[index].map((section: any, idx: number) => (
									items[index].sectionId == section.placeId ? (
										<option key={idx} value={section.placeId}>{section.name}</option>
									) : (
										<option style={{backgroundColor:"#9cc34e"}} key={idx} value={section.placeId}>{section.name}</option>
									)
								)) : null}
							</select>
						</div>

						<div className="Itemlist" style={{display:"inline-block",float:"left",minWidth:"280px",width:"20%"}}>
							<p>RFID코드</p>
							<SelectBoxStyleForRFID>
								<button
									className={selectedButtons[index] === 'new' ? 'selected' : 'unselected'}
									onClick={() => handleButtonClick('new', index)}>
									신규
								</button>
								<button
									className={selectedButtons[index] === 'reuse' ? 'selected' : 'unselected'}
									onClick={() => handleButtonClick('reuse', index)}>
									재사용
								</button>
								{selectedButtons[index] === 'new' ?
									<input type="text" name="boxName" onChange={handleChange} data-statekey="boxName" data-index={index} placeholder="직접 입력해주세요." />
									:
									<select name="boxName" onChange={handleChange} data-statekey="boxName" data-index={index} disabled={RFIDList.length === 0}>
										<option style={{backgroundColor:"#9cc34e"}} value="">{RFIDList.length > 0 ? "선택해주세요." : "재사용할 코드가 없습니다."}</option>
										{RFIDList && RFIDList.length > 0 && RFIDList.map((rfid: any, idx: number) => (
											items[index].boxName === rfid ? (
												<option key={idx} value={rfid}>{rfid}</option>
											) : (
												<option style={{ backgroundColor: "#9cc34e" }} key={idx} value={rfid}>{rfid}</option>
											)
										))}
									</select>
								}
							</SelectBoxStyleForRFID>
						</div>

						<div className="Itemlist" onChange={handleChange} style={{display:"inline-block",float:"left",minWidth:"180px",width:"20%"}}>
							<p>사육 곤충{items[index].productCode}</p>
							<select name="insect" data-statekey="productCode" data-index={index}>
								{insectList && insectList.map((insect: any, idx: number) => (
									items[index].productCode === insect.productCode ? (
										<option key={idx} value={insect.productCode}>{insect.productName}</option>
									) : (
										<option style={{backgroundColor:"#9cc34e"}} key={idx} value={insect.productCode}>{insect.productName}</option>
									)
								))}
							</select>
						</div>

						<div className="Itemlist" style={{display:"inline-block",float:"left",minWidth:"180px",width:"20%"}}>
							<p>사육 시작일</p>
							<input type="date" name="startday" onChange={handleChange} data-statekey="startFarmDate" data-index={index} value={items[index].startFarmDate} />
						</div>
					</styles.AddBoxItemList>

				))}

				<styles.ButtonBox>
					<button className="remove" onClick={() => { handleRemove(); }}>
						<p className="radius">-</p>
						<p className="text">삭제</p>
					</button>
					<button className="add" onClick={() => { handleAdd(); }}>
						<p className="radius add">+</p>
						<p className="text">추가</p>
					</button>
				</styles.ButtonBox>
			</styles.AddBoxItemContainer>
		</styles.Container>
	);
};

export default BoxAdd;
